import React, { Component } from 'react'
import * as Subheader from '../services/Subheader'
import * as Service from '../services/Create'
import './Home.css'





export default class Clientes extends Component {
  
        constructor(props) {
        super(props)
  
        this.state = {
            Form: "",
            Result: "",
            TableList: "",
           
        }
      
    
    }
   

    componentDidMount() {
        this.setState({Form: <Service.Controller action="showForm" page="Reportes" />})
   
    }


    render() {
        
        return (
            
            <div className="container mt-5 text-start">
                <div className="row">
                    <div className='col-lg-12 col-sm-12'>
                    {this.state.Form}
                    </div>
                  
                        </div>
                        <br/>
                        <br/>
                       <table class="table">
  <thead>
    <tr>
    
      <th scope="col">Nombre/Razon Social</th>
      <th scope="col">CEDULA/RNC</th>
      <th scope="col">Riesgo</th>
    </tr>
  </thead>
  <tbody>
    <tr>
    
      <td><a href="/created">Rosendo Yanez</a></td>
      <td>001-29323-3</td>
      <td>Alto</td>
    </tr>
    <tr>
     
      <td><a href="/created">Jacob</a></td>
      <td>234234-4324</td>
      <td>Bajo</td>
    </tr>
    <tr>
     
      <td><a href="/created">Larry</a></td>
      <td>093284093284</td>
      <td>Bajo</td>
    </tr>
  </tbody>
</table>
                    {this.state.Result}
                   

               

                        
            </div>
           


        )
    }
}
